import React, { FC } from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import PriceDisplay, { TCountryId } from '@/src/components/sarComponent';
import { Link, usePathname } from '@/src/i18n/navigation';
import { Routes } from '@/src/routes/routes';
import { Wallet } from 'lucide-react';
import { cn } from '@/src/lib/utils/command';
import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEvents } from '@/src/lib/amplitude/events';
type Props = {
  walletBalance: number;
  countryId?: TCountryId;
};
const WalletComponent: FC<Props> = ({ walletBalance, countryId }) => {
  const t = useTranslations('account');
  const pathname = usePathname();
  const isActive = (path: string) => {
    return pathname === path;
  };

  return (
    <Link
      href={Routes.wallet}
      className={cn(
        'flex w-full flex-col items-center justify-center rounded-lg border border-solid border-[#E7E7E8] px-4 py-3',
        isActive(Routes.wallet) ? 'opacity-100' : 'opacity-70',
      )}
      onClick={() => trackEvent(AmplitudeEvents.wallet_clicked)}
    >
      <div className="flex items-center gap-2">
        <Wallet fill={isActive(Routes.wallet) ? '#000' : 'none'} />
        <h2>{t('wallet')}</h2>
      </div>

      <div>
        <h2 className="font-bold">
          <span className="flex gap-1 ltr:flex-row-reverse">
            <PriceDisplay price={walletBalance} countryId={countryId as TCountryId} size="medium" />
          </span>
        </h2>
      </div>
    </Link>
  );
};

export default WalletComponent;
